
import { Id, RemoteData } from 'app/infrastructure/remote-data';
import { DashboardLayoutDefinition } from './types-store';
import { FavouriteDefinition, ApiResponse, TextCollection, FavouriteDefinitionResponse } from 'app/types-shared';
import { DrillDownModel, DrillDownResult } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { queryFromSearchParams } from 'app/area/shared/navigation';

export const endpoint = {
  dashboard: 'dashboard',
  dashboardFavouriteDefinition: 'favourite/definition/draft',
  dashboardMainDefinition: 'favourite/definition/draft/template/dashboard',
  updateMainDefinition: 'favourite/definition/draft',
  favourite: 'statisticalReport',
  caseReport: 'case/report' 
};

export const api = {

  /**
   * Fetch a favourite in the context of a dashboard.
   */
  executeFavourite: async (
    definition: FavouriteDefinition,
    dashboardId: number,
    startIndex?: number,
    maxResults?: number,
    ovverideApi?: boolean
  ) => {

    const request = {
      favouriteDefinition: definition,
      connectedFavourite: dashboardId
    };

    const baseApi = `${endpoint.dashboard}/${dashboardId}`;
    const apiPath = ovverideApi ? `${endpoint.caseReport}/favourite` : 'favourite';
    const response = await new RemoteData(`${baseApi}/${apiPath}/${definition.favourite.v}`)
      .resource<any>()
      .filter({
        ...(!!startIndex && { startIndex }),
        ...(!!maxResults && { maxResults })
      })
      .create(request, false);

    const json = await response.json();

    json.data.id = json.data.favourite;

    return json.data;
  },

  /**
   * Fetch the dashboard type definition.
   */
  dashboardLayoutDefinition: async (dashboardType: Id, layoutTypeContextId: number): Promise<DashboardLayoutDefinition> => {
    const response = await new RemoteData(endpoint.dashboard)
      .resource<ApiResponse<DashboardLayoutDefinition>>()
      .withId(dashboardType)
      .filter({
        layoutTypeContextId: layoutTypeContextId
      })
      .single();

    return response.data;
  },

  /**
   * Creates dashboard main favourite and return its number.
   */
  createMainFavourite: async (
    dashboardType: Id,
    queryParameters?: {[key:string]: string | number}
    ): Promise<FavouriteDefinitionResponse<number>> => {
    const response = await new RemoteData(endpoint.dashboardMainDefinition)
      .resource<any>()
      .filter({
        dashboardType,
        ...queryParameters,
        ...queryFromSearchParams(location.search)
      })
      .create(undefined, false);

    return await response.json();
  },

  /**
   * Drill down from dashboard.
   */
  drillDown: async (dashboardId: number, favouriteId: number, drillDownModel: DrillDownModel): Promise<DrillDownResult> => {
    const response: any = await new RemoteData(`${endpoint.dashboard}/${dashboardId}/favourite/${favouriteId}/drilldown`)
      .resource<ApiResponse<DrillDownResult>>()
      .create(drillDownModel, false);

    const json = await response.json();

    return json.data;
  },

  /**
   * Fetch tranlated texts for a given application area
   */
  textCollection: async (area: number): Promise<TextCollection> => {
    const remote = new RemoteData('text/collection');
    const response: any = await remote.resource<TextCollection>().withId(area).single();
    return response.data;
  }
};
